import React from "react";
import { Clock, MapPin, Truck, ShieldCheck, Lock } from "lucide-react";

const ITEMS = [
  { icon: Clock, title: "Resposta média: 2 horas", desc: "Analisamos e respondemos aos pedidos em menos de 2h em dias úteis." },
  { icon: MapPin, title: "Produção 100% em Portugal", desc: "Fabrico nacional, comunicação direta e sem intermediários." },
  { icon: Truck, title: "Envio expresso 24/48h", desc: "Entrega rápida para todo o país após aprovação da proposta." },
  { icon: ShieldCheck, title: "Confidencialidade CAD", desc: "Os seus modelos são tratados de forma confidencial. NDA disponível." },
];

export const Trust = () => (
  <div data-testid="trust-elements" className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
    {ITEMS.map((it) => (
      <div key={it.title} className="bg-ax-card border border-ax-border rounded-xl p-6 hover:border-ax-cyan/50 transition-colors">
        <it.icon className="w-6 h-6 text-ax-cyan mb-3" />
        <h4 className="font-heading font-semibold text-ax-text">{it.title}</h4>
        <p className="text-sm text-ax-sub mt-1.5 leading-relaxed">{it.desc}</p>
      </div>
    ))}
  </div>
);

export const Confidentiality = () => (
  <div data-testid="confidentiality-note" className="bg-gradient-to-br from-ax-card to-ax-surface border border-ax-border rounded-2xl p-8 sm:p-10 flex flex-col sm:flex-row gap-6 items-start">
    <div className="w-14 h-14 shrink-0 rounded-xl bg-ax-cyan/10 border border-ax-cyan/30 flex items-center justify-center">
      <Lock className="w-6 h-6 text-ax-cyan" />
    </div>
    <div>
      <h3 className="font-heading text-xl sm:text-2xl font-bold text-ax-text">Confidencialidade dos seus modelos</h3>
      <p className="text-ax-sub mt-3 leading-relaxed max-w-2xl">
        Sabemos que os seus ficheiros CAD são propriedade intelectual sensível. Os modelos que nos
        envia são usados exclusivamente para produzir a sua peça e nunca partilhados com terceiros.
        Se preferir, assinamos um Acordo de Confidencialidade (NDA) antes de qualquer partilha —
        basta indicá-lo no formulário.
      </p>
    </div>
  </div>
);
